module.exports = __webpack_public_path__ + "static/img/23.f9328d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/23.png
// module id = gtMN
// module chunks = 0